import { LocalizedText, useUrlSyncedTableState } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import {
    Table,
    TableActiveColumnFilters,
    TableBulkActions,
    TableHeader,
    TableProvider,
    useFullRowSelection,
} from '@optimus-web/core';
import { PortfolioRateGroupOverview, PortfolioRateGroupOverviewFilters } from '@mews-commander/data-access';
import { usePortfolioRateGroupOverview } from '../../../queries';
import { DeleteLocalRateGroupContainer } from '../../sections/components/rateGroup/DeleteLocalRateGroupContainer';
import { LinkRateGroupsWrapper } from './LinkRateGroupsWrapper';
import { useGetRateGroupColumns } from './tableMapping';

export const RateGroupsTable = () => {
    const columns = useGetRateGroupColumns();
    const [tableState, setTableState] = useUrlSyncedTableState<
        PortfolioRateGroupOverview,
        PortfolioRateGroupOverviewFilters
    >({
        columns,
        pageSize: 50,
    });

    const { data, isFetching } = usePortfolioRateGroupOverview(tableState);

    const { selectedRowsData, rowSelection, setRowSelection, hasRowsSelected, selectedRowsCount, resetRowSelection } =
        useFullRowSelection(data?.data);

    return (
        <>
            <TableProvider columns={columns} state={tableState} onStateChange={setTableState} as="div">
                <TableHeader
                    title={<LocalizedText textKey={TextKey.RateGroupTableTitle} />}
                    subTitle={data?.totalRowCount || '0'}
                />
                <TableActiveColumnFilters />
                <TableBulkActions
                    disabled={!hasRowsSelected}
                    leftSide={
                        hasRowsSelected && (
                            <LocalizedText textKey={TextKey.SelectedItems} substitutes={{ count: selectedRowsCount }} />
                        )
                    }
                    rightSide={
                        <>
                            <LinkRateGroupsWrapper
                                selectedRateGroups={selectedRowsData}
                                onSuccess={resetRowSelection}
                            />
                            <DeleteLocalRateGroupContainer
                                rateGroups={selectedRowsData}
                                isTableBulkAction
                                onSuccess={resetRowSelection}
                            />
                        </>
                    }
                />
                <Table
                    uniqueRowId="id"
                    data={data?.data || []}
                    amountOfRows={data?.totalRowCount ?? 0}
                    loading={isFetching}
                    rowSelection={{
                        rowSelection,
                        onRowSelectionChange: setRowSelection,
                    }}
                    fixedFirstColumn
                    fixedLastColumn
                />
            </TableProvider>
        </>
    );
};
